import React from 'react';
import './News.css';

interface Props {
  title: string;
  author: string;
  date: string;
  description: string;
  url: string;
}

const NewsCard: React.FC<Props> = ({ title, author, date, description, url }) => {
  return (
    <div className="news-card">
      <h4>{title}</h4>
      <p><strong>Author:</strong> {author || "Unknown"}</p>
      <p><strong>Date:</strong> {new Date(date).toLocaleDateString()}</p>
      <p>{description}</p>
      <a href={url} target="_blank" rel="noopener noreferrer">Read More</a>
    </div>
  );
};

export default NewsCard;
